// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import styles from './cms_switcher.module.less';
import {Button} from '../../../../hola/pub/lib/button';
import {App_context} from 'hola_app_context';
import cn from 'classnames';

export const Cms_switcher = ({caption, on_click, secondary = false})=>{
    const {user, is_client} = useContext(App_context);
    if (!is_client)
      return <Fragment/>;
    if (!user?.allow_edit_content)
      return <Fragment/>;
    return <div className={cn(styles.cms_switcher,
      secondary && styles.cms_switcher_secondary)}>
      <Button
        size={'lg'}
        caption={caption}
        on_click={on_click}
        round={false}
      />
    </div>;
};
